import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";
import { AddendumsResponse } from "types";

function useAddendums(encounterId: string) {
  return useAxiosQuery(["addendums", { encounterId }], () =>
    axiosChartInstance.get<AddendumsResponse>(`v1/addendum/${encounterId}`)
  );
}

export { useAddendums };
